
import { IStorage } from './index';
export class MemoryStorage implements IStorage {
    private state: any = {};

    public setItem(key, value) {
        this.state[key] = value;
    }

    public getItem(key) {
        return this.state[key];
    }
}
